module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"validationError":"Ce champ est obligatoire"},"en":{"validationError":"This field is required"}}')
  delete Component.options._Ctor
}
